export const zIndex = () => ({
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 3300,
  modal: 3300,
  snackbar: 1400,
  tooltip: 4500,
  fullscreen: 3400,
});